export default __webpack_public_path__ + "static/media/pc-37.e2de94cf.webp";